import Client from '../../services/client';
import {
    getReportGradingRoute,
} from './routes';

export const gradeReport = (id, questionNumber, body) => Client.put(getReportGradingRoute(id, questionNumber), body);
